module.exports = __webpack_public_path__ + "img/idr_peq.3f8efdef.png";